import ApiCity from 'types/api/City';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import City from 'models/City';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {
    promoted?: boolean;
}
export const list = async (params?: ListParams): Promise<ListCollection<City>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicCities, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.Cities];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiCity) => new City(element)),
        meta: resource.meta,
    };
};

export interface SingleParams {
    slug: string | string[];
}

export const single = async (params: SingleParams): Promise<City> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicCityBySlug, params),
    });

    const data = response?.payload?.data;
    const resource: ApiCity = data && data[ApiResources.City];


    return new City(resource);
};

export interface SingleByShortSlugParams {
    slug: string | string[];
}
export const singleByShortSlug = async (params: SingleByShortSlugParams): Promise<City> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicCityByShortSlug, params),
    });

    const data = response?.payload?.data;
    const resource: ApiCity = data && data[ApiResources.City];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new City(resource);
};